/** Remove tudo que não é dígito. */
export function stripPhoneDigits(value: string): string {
  return value.replace(/\D/g, '');
}

/** Máscara BR: (62) 99999-9999 ou (62) 9999-9999 */
export function formatPhoneBrMask(digits: string): string {
  const d = stripPhoneDigits(digits).slice(0, 11);
  if (d.length <= 2) return d.length ? `(${d}` : '';
  if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  if (d.length <= 10) {
    return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  }
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
}

/** Valida telefone BR (10 ou 11 dígitos locais). */
export function isValidPhoneBr(digits: string): boolean {
  const d = stripPhoneDigits(digits);
  return d.length === 10 || d.length === 11;
}

/** Converte para E.164 BR (só dígitos, com 55). */
export function toPhoneE164Br(digits: string): string {
  const d = stripPhoneDigits(digits);
  if (d.length === 10 || d.length === 11) return `55${d}`;
  return d;
}
